





















import { mapActions, mapMutations } from "vuex";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Folder, FolderUp, Place, Imageset } from "@wwtelescope/engine";
import { GotoTargetOptions } from "@wwtelescope/engine-helpers";
import { ImageSetType, Thumbnail } from "@wwtelescope/engine-types";

@Component
export default class FolderView extends Vue {
  @Prop() rootFolder!: Folder;
  @Prop() flexDirection!: "row" | "column";
  items: Thumbnail[] | null = null;
  lastSelectedItem: Thumbnail | null = null;

  gotoTarget!: (opts: GotoTargetOptions) => Promise<void>;
  setBackgroundImageByName!: (imagesetName: string) => void;
  setForegroundImageByName!: (imagesetName: string) => void;

  beforeCreate(): void {
    this.$options.methods = {
      ...this.$options.methods,
      ...mapMutations("wwt-embed", [
        "setBackgroundImageByName",
        "setForegroundImageByName"
      ]),
      ...mapActions("wwt-embed", [
        "gotoTarget"
      ])
    };
  }

  created(): void {
    this.items = [];
    
    for (const c of this.rootFolder.get_children() || []) {
      if (c instanceof Place) {
        this.items.push(c);
      }
    }
    // if (this.items?.length > 0) {
    //   this.selectItem(this.items[0]);
    // }
  }

  selectItem(item: Thumbnail): void {
    this.lastSelectedItem = item;
    if (item instanceof Folder || item instanceof FolderUp) {
      this.items = item.get_children();
    } else if (item instanceof Imageset) {
      const type = item.get_dataSetType();
      this.setForegroundImageByName(item.get_name());
      if (type === ImageSetType.planet) {
        this.setBackgroundImageByName(item.get_name());
      }
    } else if (item instanceof Place) {
      const imageset = item.get_backgroundImageset();
      if (imageset !== null) {
        this.setForegroundImageByName(imageset.get_name());
      }
      this.gotoTarget({
        place: item,
        noZoom: false,
        instant: false,
        trackObject: true
      });
    }
  }

  get cssVars() {
    return {
      "--flex-direction": this.flexDirection
    };
  }

}
